export default "__VITE_ASSET__rctLTH$p__"